export const LineIcon = () => {
  return (
    <svg width="1" height="26" viewBox="0 0 1 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="0.5" y1="2.18557e-08" x2="0.499999" y2="26" stroke="white" />
    </svg>
  )
}
